import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./en.json"
import fr from "./fr.json"

/* TODO: add in common function */
const storedLanguage =
  localStorage.getItem("language") || navigator.language.split("-")[0] || "fr"

i18n.use(initReactI18next).init({
  lng: storedLanguage,
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
  },
})

export default i18n
